import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import {
  bodyFont, CARD_RADIUS, cardShadow, cardShadowHover, homeColors, homeEase,
  REQUIREMENT_CARD_HEIGHT, REQUIREMENT_CARD_HEIGHT_MOBILE,
} from '../style/homeStyles';

// Ícono arriba y texto centrado debajo. El minHeight es solo un piso: una tarjeta de dos líneas
// crece por encima.
const RequirementCard = ({ text, Icon, isMobile }) => (
  <Box
    sx={{
      position: 'relative',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: isMobile ? '14px' : '18px',
      padding: isMobile ? '24px 20px' : '30px 24px',
      minHeight: isMobile ? REQUIREMENT_CARD_HEIGHT_MOBILE : REQUIREMENT_CARD_HEIGHT,
      height: '100%',
      backgroundColor: homeColors.white,
      borderRadius: CARD_RADIUS,
      boxShadow: cardShadow,
      transition: `transform .35s ${homeEase}, box-shadow .35s ${homeEase}`,
      '&:hover': { transform: 'translateY(-2px)', boxShadow: cardShadowHover },
      '&:hover .home-req-icon': { transform: 'rotate(-6deg) scale(1.06)', backgroundColor: homeColors.pink100 },
      '@media (prefers-reduced-motion: reduce)': {
        '&:hover, &:hover .home-req-icon': { transform: 'none' },
      },
    }}
  >
    <Box
      className="home-req-icon"
      sx={{
        width: isMobile ? 48 : 64,
        height: isMobile ? 48 : 64,
        flexShrink: 0,
        borderRadius: isMobile ? '16px' : '20px',
        backgroundColor: homeColors.pink50,
        color: homeColors.pink,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: `transform .4s ${homeEase}, background-color .25s ${homeEase}`,
      }}
    >
      <Icon sx={{ fontSize: isMobile ? 26 : 30 }} />
    </Box>

    <Box sx={{
      flex: 'none', minWidth: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}
    >
      <Typography
        component="p"
        sx={{
          fontFamily: bodyFont,
          fontWeight: 500,
          fontSize: isMobile ? 16 : 18,
          lineHeight: 1.4,
          letterSpacing: '-0.01em',
          color: homeColors.ink,
          maxWidth: isMobile ? 260 : 290,
          textAlign: 'center',
        }}
      >
        {text}
      </Typography>
    </Box>

    {/* Barrido de brillo: corre una vez, cuando el Reveal que envuelve la tarjeta entra en viewport. */}
    <Box
      aria-hidden="true"
      sx={{
        position: 'absolute',
        inset: 0,
        borderRadius: 'inherit',
        pointerEvents: 'none',
        background: `linear-gradient(110deg,
          transparent 25%,
          rgba(218,0,103,0.10) 45%,
          rgba(218,0,103,0.18) 50%,
          rgba(218,0,103,0.10) 55%,
          transparent 75%)`,
        transform: 'translateX(-110%)',
        '@keyframes homeReqShine': { to: { transform: 'translateX(110%)' } },
        '.home-reveal.in &': { animation: `homeReqShine 1.4s ${homeEase} .25s forwards` },
        '@media (prefers-reduced-motion: reduce)': {
          '.home-reveal.in &': { animation: 'none' },
        },
      }}
    />
  </Box>
);

RequirementCard.propTypes = {
  text: PropTypes.string.isRequired,
  Icon: PropTypes.elementType.isRequired,
  isMobile: PropTypes.bool,
};

RequirementCard.defaultProps = {
  isMobile: false,
};

export default RequirementCard;
